import { UserPreferencesData } from './types';

export const USER_PREFERENCES_DATA_NAME: string = 'userData';
export const DEFAULT_USER_PREFERENCE_DATA: UserPreferencesData = {
  favouriteStocks: [],
  recentlyViewedStocks: [],
  hasRequestedEuAccount: false,
  hasSeenWelcomePopup: false,
};
